// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__uX38P","back_app":"Menu_back_app__hJ+5z","back_icon":"Menu_back_icon__Loy9h","app_name":"Menu_app_name__Xarqj"};